import { Config, PqApp } from '@sabyr-dev/mist_core/app';
import {
	Attempt, ElibraryAttemptStateDataSource, ElibraryGlobalStateDataSource,
	ElibraryItemDataSource, ElibraryListDataSource, ElibraryMetadataDataSource,
	ElibraryScoreDataSource, ElibrarySettingsDataSource, Product, Question, Quiz
} from "./datasource";
import {
	ElibraryChartFrontend, ElibraryHeaderFrontend, ElibraryListFrontend,
	ElibraryQuestionFrontend, ElibraryScoreFrontend, ElibrarySectionFrontend,
	ElibrarySettingsFrontend, ElibrarySummaryFrontend
} from "./frontend";
import {
	ListDataSource, MetadataDataSource, PqDataSourceFactory, PqItemDataSource,
	ScoreDataSource, Serializer, SettingsDataSource, StateDataSource,
	StateInitializer
} from "@sabyr-dev/mist_core/model/datasource";
import {
	ChartFrontend, FrontendFactory, ListFrontend, PqHeaderFrontend,
	PqItemFrontend, ScoreFrontend, SectionFrontend, SettingsFrontend,
	SummaryFrontend
} from "@sabyr-dev/mist_core/view/frontend";
import {
	AttemptState, GlobalState,
} from "@sabyr-dev/mist_core/model/datasource/state";

export class ElibraryDataSourceFactory extends PqDataSourceFactory<Product, Attempt, Quiz, Question> {
	listDataSource(item: Serializer<Question>): ListDataSource<Question> { return new ElibraryListDataSource(item); }
	metadataDataSource(): MetadataDataSource<Product, Attempt> { return new ElibraryMetadataDataSource(); }
	itemDataSource(): PqItemDataSource<Product, Attempt, Question> { return new ElibraryItemDataSource(); }
	scoreDataSource(quiz: Serializer<Quiz>): ScoreDataSource<Attempt, Quiz> { return new ElibraryScoreDataSource(quiz); }
	settingsDataSource(): SettingsDataSource<Product> { return new ElibrarySettingsDataSource(); }
	globalStateDataSource(initializer: StateInitializer<GlobalState>): StateDataSource<GlobalState> {
		return new ElibraryGlobalStateDataSource(initializer);
	}
	attemptStateDataSource(initializer: StateInitializer<AttemptState>): StateDataSource<AttemptState> {
		return new ElibraryAttemptStateDataSource(initializer);
	}
}

export class ElibraryFrontendFactory extends FrontendFactory<Product, Attempt, Quiz, Question> {
	headerFrontend(item: Serializer<Question>): PqHeaderFrontend<Question> { return new ElibraryHeaderFrontend(item); }
	listFrontend(item: Serializer<Question>): ListFrontend<Question> { return new ElibraryListFrontend(item); }
	itemFrontend(item: Serializer<Question>): PqItemFrontend<Question> { return new ElibraryQuestionFrontend(item); }
	scoreFrontend(): ScoreFrontend { return new ElibraryScoreFrontend(); }
	sectionFrontend(quiz: Serializer<Quiz>, item: Serializer<Question>): SectionFrontend<Quiz, Question> { return new ElibrarySectionFrontend(quiz, item); }
	settingsFrontend(item: Serializer<Question>): SettingsFrontend<Question> { return new ElibrarySettingsFrontend(item); }
	summaryFrontend(product: Serializer<Product>): SummaryFrontend<Product> { return new ElibrarySummaryFrontend(product); }
	chartFrontend(product: Serializer<Product>): ChartFrontend<Product, Attempt, Quiz> { return new ElibraryChartFrontend(product); }
}

export default class Elibrary {
	static datasource: ElibraryDataSourceFactory = new ElibraryDataSourceFactory();
	static frontend: ElibraryFrontendFactory = new ElibraryFrontendFactory();

	static constructOverviewApp(config: Config): PqApp<Product, Attempt, Quiz, Question> {
		return PqApp.constructOverview(Elibrary.datasource, Elibrary.frontend, config);
	};
	static constructTestApp(config: Config): PqApp<Product, Attempt, Quiz, Question> {
		return PqApp.constructTest(Elibrary.datasource, Elibrary.frontend, config);
	};
	static constructReviewApp(config: Config): PqApp<Product, Attempt, Quiz, Question> {
		return PqApp.constructReview(Elibrary.datasource, Elibrary.frontend, config);
	};
}